var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 21,
    viewBox: "0 0 75 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2104 0.983398V19.672H59.5779V6.81787H59.6689L65.2205 16.2077H65.5848L71.3186 6.81787H71.4096V19.672H74.7771V0.983398H70.9548L65.767 10.3733H65.6759L60.2148 0.983398H56.2104ZM0.41748 0.983398V19.672H3.96709V7.0002H4.05816L12.7046 19.672H16.4363V0.983398H12.8867V13.4728H12.7956L4.24016 0.983398H0.41748ZM33.9113 12.5612C33.9113 17.3929 36.8238 20.1278 41.7386 20.1278C46.2895 20.1278 49.657 17.3929 49.657 12.5612V0.983398H45.9253V12.5612C45.9253 14.8403 44.8332 16.7547 41.7386 16.7547C38.6441 16.7547 37.6429 14.5668 37.6429 12.2877V0.983398H33.9113V12.5612ZM23.6266 0.983398V19.672H27.3582V0.983398H23.6266Z",
    fill: "#545B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNium);
export default __webpack_public_path__ + "static/media/nium.f1e9b6cc2aff3ffe7736617e253f307f.svg";
export { ForwardRef as ReactComponent };